import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import ThemeSwitcher from "../ThemeSwitcher";
import { useLoteProgress } from "../Emplacar/Lote/LoteProgressContext";
import { useDebitosLote } from "../Debitos/Lote/DebitosLoteContext";

function Topo(props){
    
    const titulo = props.titulo;
    const breadcrumbs = props.breadcrumbs;
    const btnincluir = props.btnincluir;
    const destino = props.destino;

    let navigate = useNavigate();

    const logout = () => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('Nome');
        sessionStorage.removeItem('Key');
        
        if(props.admin){
            navigate('/admin');
        }else{
            navigate('/');
        }        
    }

    const [nomeUsuario, setNomeUsuario] = useState('');

    useEffect(() => {
        CarregarNome();        
    }, []);

    function CarregarNome(){
        setNomeUsuario(sessionStorage.getItem('Nome'));
    }

    const showThemeSwitcher = (process.env.REACT_APP_SHOW_THEME_SWITCHER ?? 'true').toLowerCase() === 'true';

    const { abrirPainelLote, progressoPercentual } = useLoteProgress();
    const percentualNormalizado = Number.isFinite(progressoPercentual)
      ? Math.max(0, Math.min(100, Math.round(progressoPercentual)))
      : 0;
    const progressAriaLabel = percentualNormalizado > 0
      ? `Progresso do lote (${percentualNormalizado}% concluído)`
      : "Progresso do lote";
    const {
        abrirPainel: abrirPainelDebitos,
        temConsulta: temConsultaDebitos,
        resumo: resumoDebitos,
        status: statusDebitos,
        consulta: consultaDebitos,
    } = useDebitosLote();
    const exibirBotaoDebitos = temConsultaDebitos || statusDebitos === "loading";
    const debitosBadge =
        Number.isFinite(resumoDebitos?.totalVeiculos) && resumoDebitos.totalVeiculos > 0
            ? resumoDebitos.totalVeiculos
            : null;
    const calcularPercentualDebitos = (jobResumo) => {
        if (!jobResumo) {
            return 0;
        }
        const total = Number(jobResumo.total);
        if (!Number.isFinite(total) || total <= 0) {
            return 0;
        }
        const processed = Number(jobResumo.processed);
        const valorProcessado = Number.isFinite(processed) ? processed : 0;
        return Math.max(0, Math.min(100, Math.round((valorProcessado / total) * 100)));
    };
    const percentualDebitos = calcularPercentualDebitos(consultaDebitos?.jobResumo);
    const debitosProgressLabel =
        percentualDebitos > 0
            ? `Progresso dos débitos em lote (${percentualDebitos}% concluído)`
            : "Progresso dos débitos em lote";
    const debitosAriaLabel =
        debitosBadge !== null
            ? `${debitosProgressLabel}. Último retorno com ${debitosBadge} veículo(s).`
            : debitosProgressLabel;

    return (
        <div class="row row-padding-conteudo topo-conteudo align-items-center">
            <div class="col-12 d-flex justify-content-end align-items-center gap-2 user tablet-hide mobile-hide">
                {showThemeSwitcher && <ThemeSwitcher />}
                {exibirBotaoDebitos && (
                    <button
                        type="button"
                        class="btn-progress btn-progress--round"
                        onClick={abrirPainelDebitos}
                        style={{ "--progress-fill": `${percentualDebitos}%` }}
                        aria-label={debitosAriaLabel}
                        title={debitosAriaLabel}
                    >
                        <span class="btn-progress__percent btn-progress__percent--round" aria-hidden="true">
                            D
                        </span>
                    </button>
                )}
                {percentualNormalizado > 0 && (
                    <button
                        type="button"
                        class="btn-progress btn-progress--round"
                        onClick={abrirPainelLote}
                        style={{ "--progress-fill": `${percentualNormalizado}%` }}
                        aria-label={progressAriaLabel}
                        title={progressAriaLabel}
                    >
                        <span class="btn-progress__percent btn-progress__percent--round" aria-hidden="true">
                            E
                        </span>
                    </button>
                )}
                <div class="dropdown">
                    <button class="btn-dropdown btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        {nomeUsuario}
                    </button>
                    <ul class="dropdown-menu">
                        <li>
                            <button type="button" class="dropdown-item align-icon">
                                <span class="material-symbols-outlined">manage_accounts</span>Editar Perfil
                            </button>
                        </li>
                        <li>
                            <button type="button" class="dropdown-item align-icon action-disable" onClick={logout}>
                                <span class="material-symbols-outlined">logout</span>Logout
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-6 text-start topo-conteudo">
                <h1>{titulo}</h1>  
                <nav  aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        { breadcrumbs.map( (menu) => (
                            <li class="breadcrumb-item"><span>{menu}</span></li>
                            ))
                        }
                    </ol>
                </nav>
            </div>                  

            <div class="col-6 text-end topo-conteudo">
                {btnincluir ? <a href={destino} class="btn btn-primary-blue">Novo</a> : ''}
            </div>                               
        </div>
    )

}

export default Topo;
